import type {SignUpResp} from "~/types/user";
import Alert from "~/utils/Alert";
import type {EventSimple} from "~/types/event";

export const useFavorites = () => {
  const baseUrl = '/favorites'
  const {fetch} = useAjax()
  const favorites = useState<string[]>('user-favorites', () => [])

  const saveFavorite = async (eventId: string) => {
    try {
      await fetch<SignUpResp>(baseUrl, {
        method: "POST",
        body: eventId,
      })
      if (favorites.value.includes(eventId)) {
        favorites.value = favorites.value.filter(f => f !== eventId)
      } else {
        favorites.value.push(eventId)
      }
    } catch (e: any) {
      Alert.error(e.message);
    }
  }

  const findAllFavorite = async () => {
    try {
      const data =  await fetch<string[]>(baseUrl + '/event-ids')
      favorites.value = data || []
    } catch (e: any) {
      return []
    }
  }

  const findAllFavorites = async (): Promise<EventSimple[]> =>{
    try {
      return await fetch<EventSimple[]>(baseUrl)
    } catch (e: any) {
      return [];
    }
  }

  const isFavorite = (eventId: string) => {
    return favorites.value.includes(eventId)
  }

  return {
    findAllFavorite,
    isFavorite,
    saveFavorite,
    findAllFavorites
  }
}
